import { isExistent } from 'helpers';

function createUrl(...params: Array<string | undefined>): string {
  return params.filter(isExistent).join('/');
}

export function createAbsoluteUrl(...params: Array<string | undefined>): string {
  return '/' + createUrl(...params);
}
